<div class="body">
  <clz-header></clz-header>
  <div class="page-box">
    <router-outlet></router-outlet>
  </div>
  <clz-footer></clz-footer>
</div>